<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="6">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox
                                v-model="form.semester_id"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="program" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="form.program_code"
                                               :faculty_code="form.faculty_code"
                                               :department_code="form.department_code"></program-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="quota" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input v-model="form.quota" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="quota" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox v-model="form.application_group"
                                                 code="conservatory_application_quota_placement_type"
                                                 :multiple="false"
                                                 :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import ConservatoryApplicationQuotasService from "@/services/ConservatoryApplicationQuotasService"
//Components
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        ParameterSelectbox
    },
    data() {
        return {
            formLoading: false,
            form: {
                semester_id: null,
                program_code: null,
                faculty_code: null,
                department_code: null,
                quota: null,
            }
        }
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.formLoading = true;
                ConservatoryApplicationQuotasService.store(this.form)
                    .then((response) => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("createFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    }).finally(() => {
                    this.formLoading = false;
                });
            }
        }
    }
}
</script>
